<template>
  <v-dialog v-model="dialog" persistent max-width="300px">
    <v-card grid-list-lg>
      <ModelTitle title="New Collection" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              focusable
              :error-messages="nameErrors"
              :hide-details="nameErrors.length === 0"
              v-model.trim="Collection.name"
              ref="categoryName"
              outlined
              @change="changeName" autofocus
              @focus="$event.target.select()"
              dense
              label="Name"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import CollectionService from "../service.js";
import GlobalFunction from "@/mixins/GlobalFunction";
// import ImageView from "@/components/Image/ImageView";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-Collection",
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      searchName: null,
      loading: false,
      dialog: false,
      Collection: {
        name: null,
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Collection: {
      name: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      // this.$nextTick(() => {
      //   this.$refs.categoryName.focus();
      // });
    },
  },
  // components: {
  //   ImageView,
  // },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Collection.name.$dirty) return errors;
      if (!this.$v.Collection.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    imageChange(val) {
      if (val) {
        this.Collection.imageUrl = val;
      }
    },
    changeName() {
      this.Collection.name = this.properCase(this.Collection.name);
      this.searchName = this.Collection.name;
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Collection = {
        name: null,
        imageUrl: null,
        note: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return CollectionService.create(this.Collection)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Collection is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
